import { render, staticRenderFns } from "./Seating.vue?vue&type=template&id=5eb80fd3"
import script from "./Seating.vue?vue&type=script&lang=js"
export * from "./Seating.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports